import { HttpClient, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Utilerias } from '../helpers/Utilerias';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorsHandleService {

  constructor(private http: HttpClient) { }

   handleError(error: HttpErrorResponse) {
      console.log('Error en Usuarios Service' + error.message);
      Utilerias.alertClient('Error al hacer la petición', 'Intente de nuevo', 1);
      if (error.status === HttpStatusCode.Unauthorized) {
        Utilerias.closeSesion(this.http);
        return throwError(() => new Error('!Error Unauthorized, verifique sus credenciales!'))
      }
      return throwError(() => new Error('!Fuera de servicio, intente nuevamente!'))
    }
}
